import React from 'react'
import PropTypes from 'prop-types'
import IconError from "./../../../public/images/iconError.svg"

const Error = (props) => {
    const hasErrors = Object.keys(props.errors).length > 0
    const getErrors = () => {
        if (typeof (props.errors) !== 'object') {
            return <div dangerouslySetInnerHTML={{ __html: props.errors }} />
        }

        return Object.keys(props.errors).map((item, key) => {
            if (typeof props.errors[item] === 'object') {
                return props.errors[item].map((innerItem, innerKey) => {
                    return <div className={props.className} key={innerKey} dangerouslySetInnerHTML={{ __html: innerItem }} />
                })
            } else {
                return <div key={key} dangerouslySetInnerHTML={{ __html: props.errors[item] }} />
            }
        })
    }

    return (
        <div className='row-error my-2'>
            <img src={IconError} alt='Error Symbol'/>
            {hasErrors ? getErrors() : 'Oops! Please check all fields are filled in correctly.'}
        </div>
    )
}

Error.propTypes = {
    errors: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ])
}

export default Error


// WEBPACK FOOTER //
// ./resources/js/components/Error.js